import { render, staticRenderFns } from "./SSLandingView.vue?vue&type=template&id=4b2ffd74&scoped=true&"
import script from "./SSLandingView.vue?vue&type=script&lang=js&"
export * from "./SSLandingView.vue?vue&type=script&lang=js&"
import style0 from "./SSLandingView.vue?vue&type=style&index=0&id=4b2ffd74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2ffd74",
  null
  
)

export default component.exports